export class PhoneNumbers {
  constructor(
    public Type: string,
    public Number: string,
    public Preferred: boolean
  ) {}
}
